import * as React from "react";

import { Stack, Typography } from "@mui/material";

import { IServerProperty } from "@/store/slices/property";
import { ProgressWithValue } from "@/components/shared";
import { useTranslation } from "react-i18next";

interface IProgressSharedProps {
  item: IServerProperty;
  hasAmount?: boolean;
}

const ProgressShared: React.FunctionComponent<IProgressSharedProps> = ({
  item,
  hasAmount = true,
}) => {
  const percent =
    item?.total_investment_percent > 100 ? 100 : item?.total_investment_percent;

  const { t } = useTranslation(["common"]);

  return (
      <Stack sx={{marginTop:"0px !important"}}>
        {hasAmount && 
          <Stack px={1} sx={{justifyContent:"space-between", marginTop:"10px !important"}} direction="row" spacing={0.5}> 
            <Stack>
              <Typography variant="smallMedium" color="text.primary">
                {t("common:total_investment_quantity")}:
              </Typography>
            </Stack>
            <Stack>
              <Typography variant="smallMedium" color="text.primary">
              {(item.total_investment_quantity &&
                item.total_investment_quantity.withCommas().withPriceUnit()) ||
                "-"}
              </Typography>
            </Stack>
          </Stack>
        }
        <Stack sx={{marginTop:"10px !important"}}>
          <ProgressWithValue value={percent} />
        </Stack>
      </Stack>
  );
};

export default ProgressShared;
